import React from "react"

import { Label } from "./Label"

export type InputLabelProps = {
  label?: string
  bold?: boolean
  mandatory?: boolean
}

export function InputLabel({ label, bold = true, mandatory }: InputLabelProps) {
  return <Label bold={bold} text={mandatory && label ? `${label}*` : label} />
}
